import { Component, Input } from '@angular/core';

export interface CdcDeltaRow {
  field_name: string;
  is_value: string;
  was_value: string;
  changed_at: string | Date;
  user_display: string;
}

type DeltaSortKey = 'field_name' | 'is_value' | 'was_value' | 'changed_at' | 'user_display';

@Component({
  selector: 'app-cdc-delta-table',
  templateUrl: './cdc-delta-table.component.html',
  styleUrls: ['./cdc-delta-table.component.scss'],
})
export class CdcDeltaTableComponent {
  /** Rows newest-first from the change_log / CDC delta API. */
  @Input() rows: CdcDeltaRow[] = [];
  /** IANA timezone for the Changed column; defaults to Eastern. */
  @Input() timezoneId = 'America/New_York';
  /** Suffix shown after the formatted timestamp (e.g. ET). */
  @Input() timezoneLabel = 'ET';

  sortKey: DeltaSortKey | null = null;
  sortDir: 'asc' | 'desc' = 'asc';

  get sortedRows(): CdcDeltaRow[] {
    const rows = this.rows || [];
    if (!this.sortKey || !rows.length) return rows;
    const key = this.sortKey;
    const dir = this.sortDir === 'asc' ? 1 : -1;
    return [...rows].sort((a, b) => {
      if (key === 'changed_at') {
        const av = new Date(a.changed_at).getTime() || 0;
        const bv = new Date(b.changed_at).getTime() || 0;
        return (av - bv) * dir;
      }
      const av = (a[key] ?? '').toString().toLowerCase();
      const bv = (b[key] ?? '').toString().toLowerCase();
      if (av < bv) return -1 * dir;
      if (av > bv) return 1 * dir;
      return 0;
    });
  }

  toggleSort(key: DeltaSortKey) {
    if (this.sortKey === key) {
      this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc';
      return;
    }
    this.sortKey = key;
    // Match API default for Changed (newest first); other columns A→Z.
    this.sortDir = key === 'changed_at' ? 'desc' : 'asc';
  }

  sortIcon(key: DeltaSortKey): string {
    if (this.sortKey !== key) return '↕';
    return this.sortDir === 'asc' ? '↑' : '↓';
  }
}
